import api from "../../utils/api";

export function normalizeUserConfig(raw) {
  return {
    alertThreshold: raw.alert_threshold ?? 3,
    notifyOnNegative: Boolean(raw.notify_on_negative),
    notifyOnAllActivity: Boolean(raw.notify_on_all_activity),
    notifyOnStatusChange: Boolean(raw.notify_on_status_change),
    notifyOnTicketReply: Boolean(raw.notify_on_ticket_reply),
  };
}

function serializeUserConfig(config) {
  return {
    alert_threshold: config.alertThreshold,
    notify_on_negative: config.notifyOnNegative,
    notify_on_all_activity: config.notifyOnAllActivity,
    notify_on_status_change: config.notifyOnStatusChange,
    notify_on_ticket_reply: config.notifyOnTicketReply,
  };
}

export async function fetchNotificationConfig() {
  const data = await api.get("/api/notifications/config/", { auth: true });
  return normalizeUserConfig(data);
}

export async function updateNotificationConfig(config) {
  const data = await api.patch(
    "/api/notifications/config/",
    serializeUserConfig(config),
    { auth: true }
  );
  return normalizeUserConfig(data);
}

export function normalizeAdminConfig(raw) {
  return {
    notifyOnNewCase: Boolean(raw.notify_on_new_case),
    notifyOnNewTicket: Boolean(raw.notify_on_new_ticket),
  };
}

export async function fetchAdminNotificationConfig() {
  const data = await api.get("/api/admin/notifications/config/", { auth: true });
  return normalizeAdminConfig(data);
}

export async function updateAdminNotificationConfig(config) {
  const data = await api.patch(
    "/api/admin/notifications/config/",
    {
      notify_on_new_case: config.notifyOnNewCase,
      notify_on_new_ticket: config.notifyOnNewTicket,
    },
    { auth: true }
  );
  return normalizeAdminConfig(data);
}

export async function fetchAdminEmailTestPreview() {
  return api.get("/api/admin/notifications/test-email/", { auth: true });
}

export async function sendAdminTestEmail() {
  return api.post("/api/admin/notifications/test-email/", {}, { auth: true });
}
